export const appColors = {
    primary: "#ff8300",
    secondary: "#6f1fb4",
    gradient1: "#ffba4b",
    gradient2: "#ff8300",
    white: "#ffffff",
    black: "#000000",
}
